/* Header state: a single attribute on <html> once the page has moved, so CSS can switch the bar
   from transparent to glass. One passive listener, one frame per burst of scrolling. */
(() => {
  const root = document.documentElement;
  let queued = false;
  const update = () => { queued = false; root.toggleAttribute('data-dn-scrolled', window.scrollY > 12); };
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();

/* The header's REAL height as --dn-header-h. Trade's --header-height is measured once and misses a header
   that wraps (the country / language pickers drop to a second line on mid widths: 93 px, not 61), so
   anything stuck "under the header" (the product tab rail) slid over it. Kept live by a ResizeObserver. */
(() => {
  const el = document.querySelector('.shopify-section-header-sticky, .section-header');
  if (!el || !('ResizeObserver' in window)) return;
  const set = () => document.documentElement.style.setProperty('--dn-header-h', `${Math.round(el.getBoundingClientRect().height)}px`);
  new ResizeObserver(set).observe(el);
  set();
})();
